// component
import Iconify from '../../components/Iconify'

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />

const conformerAdminSidebarConfig = [
  {
    title: 'داشبورد',
    path: '/conformer/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
    key: 'DASHBOARD',
  },
  {
    title: 'تیکت پشتیبانی',
    path: '/conformer/dashboard/ticket/list',
    icon: getIcon('ant-design:message-filled'),
    key: 'TICKET',
  },
  {
    title: 'تنظیمات',
    path: '/conformer/dashboard/setting',
    icon: getIcon('ant-design:setting-filled'),
    key: 'SETTING',
  },
]

export default conformerAdminSidebarConfig
